import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Shield, User } from 'lucide-react';
import axios from 'axios';

// ALWAYS use relative URL - same-origin requests only
const API = '/api';

const Navbar = ({ user, onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
      if (onLogout) onLogout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <nav className="border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to={user ? "/dashboard" : "/"} className="flex items-center space-x-2" data-testid="navbar-logo">
            <Shield className="h-8 w-8 text-primary" />
            <span className="font-heading text-2xl font-bold tracking-tight">ScanMyAd</span>
          </Link>

          <div className="flex items-center space-x-6">
            {user ? (
              <>
                <Link to="/" data-testid="nav-home">
                  <Button variant="ghost">Home</Button>
                </Link>
                <Link to="/dashboard" data-testid="nav-dashboard">
                  <Button variant="ghost">Dashboard</Button>
                </Link>
                <Link to="/scanner" data-testid="nav-scanner">
                  <Button variant="ghost">Scan Ad</Button>
                </Link>
                <Link to="/pricing" data-testid="nav-pricing">
                  <Button variant="ghost">Pricing</Button>
                </Link>
                <Link to="/account" data-testid="nav-account">
                  <Button variant="ghost" className="flex items-center gap-1">
                    <User className="h-4 w-4" />
                    Account
                  </Button>
                </Link>
                <Button onClick={handleLogout} variant="outline" data-testid="nav-logout-btn">Logout</Button>
              </>
            ) : (
              <>
                <Link to="/" data-testid="nav-home-public">
                  <Button variant="ghost">Home</Button>
                </Link>
                <Link to="/pricing" data-testid="nav-pricing-public">
                  <Button variant="ghost">Pricing</Button>
                </Link>
                <Link to="/about" data-testid="nav-about">
                  <Button variant="ghost">About</Button>
                </Link>
                <Link to="/login" data-testid="nav-login">
                  <Button variant="ghost">Login</Button>
                </Link>
                <Link to="/register" data-testid="nav-register">
                  <Button className="bg-primary text-primary-foreground hover:bg-primary/90">Get Started</Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
